import React from "react";

// fontSize lives on the FontSIzeScale container so card export scaling applies.
const spanFontStyle = (fontStyle) => {
  if (!fontStyle) return null;
  const { fontSize, ...rest } = fontStyle;
  return rest;
};

const HeadingData = (options, fontStyle) => {
  const br = <br></br>;
  const heading = options?.heading ? options.heading : "";
  if (heading === "") {
    return <></>;
  } else {
    const text = heading.split("\n");
    return text ? (
      text.map((value, index) => {
        if (index != text.length) {
          return (
            <span key={index} style={heading ? spanFontStyle(fontStyle) : null}>
              {value}
              <br />
            </span>
          );
        }
      })
    ) : (
      <></>
    );
  }
};
export default function Heading({ options, fontStyle, idx }) {
  const heading = options?.heading ? true : false;
  return (
    <div
      id={"heading_" + idx}
      className={"FontSIzeScale main-heading text-center"}
      style={{
        ...(heading ? fontStyle : {}),
        fontKerning: "none",
        fontFeatureSettings: '"kern" 0',
        textRendering: "geometricPrecision",
        WebkitFontSmoothing: "antialiased",
      }}
    >
      {HeadingData(options, fontStyle)}
    </div>
  );
}
